// src/pages/item_types/ItemTypeForm.js
import {
  Box,
  Button,
  Card,
  CardContent,
  FormControlLabel,
  FormHelperText,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Formik } from 'formik';
import * as Yup from 'yup';
import AdminHeader from '../../components/AdminHeader';
import LayoutContainer from '../../components/LayoutContainer';
import itemTypeService from '../../services/itemTypeService';
import { toUpper } from 'lodash';

const ItemTypeForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [initialValues, setInitialValues] = useState({
    type: '',
    unit: '',
    active: true,
    station_type: 'ROUTE',
  });

  useEffect(() => {
    const fetchItemType = async () => {
      if (id) {
        const response = await itemTypeService.getItemType(id);
        setInitialValues(response.data);
      }
    };
    fetchItemType();
  }, [id]);

  const validationSchema = Yup.object().shape({
    type: Yup.string().required('Type is required'),
    station_type : Yup.string().required('Type is required'),
  });

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      if (id) {
        await itemTypeService.updateItemType(id, values);
      } else {
        await itemTypeService.createItemType(values);
      }
      navigate('/item-types');
    } catch (error) {
      console.error(error); // Handle error appropriately
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <LayoutContainer>
      <AdminHeader
        title={id ? 'Edit Product Type' : 'Add Product Type'}
        backTo='/item-types'
      />
      <Box
        className='page-content-wrapper scrollable'
        p={3}
        sx={{ display: 'flex', backgroundColor: '#efefef' }}
      >
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          enableReinitialize
        >
          {({
            handleChange,
            handleBlur,
            handleSubmit,
            values,
            errors,
            touched,
          }) => (
            <form onSubmit={handleSubmit} style={{ width: '50%' }}>
              <Card>
                <CardContent>
                  <Typography variant='body2' sx={{ fontWeight: 600 }}>
                    Product Type <span style={{ color: 'red' }}>*</span>
                  </Typography>
                  <TextField
                    placeholder='Type'
                    name='type'
                    fullWidth
                    value={values.type}
                    onChange={(e) => {
                      const capitalizedValue = toUpper(e.target.value); // Capitalize first letter
                      handleChange({
                        target: {
                          name: 'type',
                          value: capitalizedValue,
                        },
                      });
                    }}
                    onBlur={handleBlur}
                    sx={{
                      backgroundColor: '#f5f5f5',
                      borderRadius: 1,
                      '& .MuiOutlinedInput-root': {
                        '& fieldset': {
                          borderColor:
                            touched.type && errors.type ? '#d32f2f' : '#ccc',
                        },
                      },
                    }}
                  />
                  {touched.type && errors.type && (
                    <FormHelperText error>{errors.type}</FormHelperText>
                  )}
                  <Typography variant='body2' sx={{ fontWeight: 600, mt:1 }}>
                   Type <span style={{ color: 'red' }}>*</span>
                  </Typography>
                  <RadioGroup
                    name='station_type'
                    // fullWidth
                    value={values.station_type || ''}
                    onChange={(e) => {
                      const capitalizedValue = toUpper(e.target.value); // Capitalize first letter
                      handleChange({
                        target: {
                          name: 'station_type',
                          value: capitalizedValue,
                        },
                      });
                    }}
                    onBlur={handleBlur}
                    row
                    sx={{ gap: 3 }}
                  >
                    <FormControlLabel
                      value='JUNCTION'
                      control={<Radio />}
                      label='Junction'
                      sx={{
                        '& .MuiFormControlLabel-label': {
                          fontSize: '0.675rem',
                          fontWeight: 500,
                          color: '#333',
                        },
                      }}
                    />
                    <FormControlLabel
                      value='ROUTE'
                      control={<Radio />}
                      label='Route'
                      sx={{
                        '& .MuiFormControlLabel-label': {
                          fontSize: '0.675rem',
                          fontWeight: 500,
                          color: '#333',
                        },
                      }}
                    />
                  </RadioGroup>
                  {touched.station_type && errors.station_type && (
                    <FormHelperText error>{errors.station_type}</FormHelperText>
                  )}
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'flex-end',
                      mt: 0.8,
                    }}
                  >
                    <Button
                      type='submit'
                      variant='contained'
                      sx={{ backgroundColor: '#be210b', textTransform: 'none' }}
                    >
                      {id ? 'Update' : 'Create'}
                    </Button>
                  </Box>
                </CardContent>
              </Card>
            </form>
          )}
        </Formik>
      </Box>
    </LayoutContainer>
  );
};

export default ItemTypeForm;
